import useMediaQuery from '@mui/material/useMediaQuery';

export const useIsSmallScreen = () => {
    const isSmallScreen = useMediaQuery('(max-width:450px)');
    return isSmallScreen;
};
